$(document).ready(function () {
    $(".select-form option").each(function() {
        if ($(this).is(":selected")) {
            $(".form-collapse").hide();
            $("#" + $(this).attr("data-collapse")).show()
        }
    })
    $(".select-form").on("change", function() {
        $(".form-collapse").hide();
        $("#" + $(this).find("option:selected").attr("data-collapse")).show()
    })

    initPricingCards();
    initContactPeopleCards();
    initPartnersMarquee();
    initContactForm();
});

function initContactForm() {
    var form = document.querySelector(".message-us__form");
    if (!form) {
        return;
    }

    var statusEl = form.querySelector(".message-us__status");
    var submitBtn = form.querySelector(".message-us__submit");

    form.addEventListener("submit", function (event) {
        event.preventDefault();

        var nameInput = form.querySelector('[name="name"]');
        var emailInput = form.querySelector('[name="email"]');
        var messageInput = form.querySelector('[name="message"]');

        var payload = {
            name: nameInput ? nameInput.value.trim() : "",
            email: emailInput ? emailInput.value.trim() : "",
            message: messageInput ? messageInput.value.trim() : "",
        };

        setContactStatus(statusEl, "", null);
        if (submitBtn) {
            submitBtn.disabled = true;
        }

        fetch("/api/contact", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify(payload),
        })
            .then(function (response) {
                return response.json().then(function (data) {
                    return { ok: response.ok, status: response.status, data: data };
                });
            })
            .then(function (result) {
                if (result.ok && result.data && result.data.status === 0) {
                    var successMessage =
                        result.data.message || "Wiadomość została wysłana. Dziękujemy!";
                    setContactStatus(statusEl, successMessage, "success");
                    showAppNotify(successMessage, "success");
                    form.reset();
                    return;
                }

                var message = "Nie udało się wysłać wiadomości. Spróbuj ponownie.";
                if (result.status === 429) {
                    message = "Wysłano zbyt wiele wiadomości. Spróbuj ponownie za chwilę.";
                } else if (result.data) {
                    if (result.data.message) {
                        message = result.data.message;
                    }
                    if (result.data.errors) {
                        var firstKey = Object.keys(result.data.errors)[0];
                        if (firstKey && result.data.errors[firstKey][0]) {
                            message = result.data.errors[firstKey][0];
                        }
                    }
                }
                setContactStatus(statusEl, message, "error");
                showAppNotify(message, "error");
            })
            .catch(function () {
                var failMessage = "Nie udało się wysłać wiadomości. Spróbuj ponownie.";
                setContactStatus(statusEl, failMessage, "error");
                showAppNotify(failMessage, "error");
            })
            .finally(function () {
                if (submitBtn) {
                    submitBtn.disabled = false;
                }
            });
    });
}

function showAppNotify(message, type) {
    var appEl = document.getElementById("app");
    var vueApp = appEl && appEl.__vue__;
    if (!vueApp || typeof vueApp.$notify !== "function" || !message) {
        return;
    }

    vueApp.$notify({
        group: "foo",
        type: type || "success",
        title: message,
    });
}

function setContactStatus(statusEl, message, type) {
    if (!statusEl) {
        return;
    }

    statusEl.hidden = !message;
    statusEl.textContent = message || "";
    statusEl.classList.remove("message-us__status--success", "message-us__status--error");
    if (type) {
        statusEl.classList.add("message-us__status--" + type);
    }
}

function initPartnersMarquee() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        return;
    }

    document.querySelectorAll(".partners").forEach(function (section) {
        var viewport = section.querySelector(".partners__viewport");
        var track = section.querySelector(".partners__track");
        var list = track && track.querySelector(".partners__list");

        if (!viewport || !track || !list || !list.children.length) {
            return;
        }

        function setup() {
            while (track.children.length > 1) {
                track.removeChild(track.lastElementChild);
            }

            var listWidth = list.getBoundingClientRect().width;
            if (listWidth <= 0) {
                return;
            }

            var copies = 2;
            while (listWidth * copies < viewport.clientWidth * 2) {
                copies += 1;
            }

            for (var i = 1; i < copies; i += 1) {
                var clone = list.cloneNode(true);
                clone.setAttribute("aria-hidden", "true");
                track.appendChild(clone);
            }

            var duration = Math.max(listWidth / 40, 12);
            track.style.setProperty("--partners-shift", listWidth + "px");
            track.style.setProperty("--partners-duration", duration + "s");
            track.setAttribute("data-animated", "true");
        }

        var images = list.querySelectorAll("img");
        var pending = images.length;

        if (pending === 0) {
            setup();
        } else {
            function onImageReady() {
                pending -= 1;
                if (pending <= 0) {
                    setup();
                }
            }

            images.forEach(function (img) {
                if (img.complete) {
                    onImageReady();
                } else {
                    img.addEventListener("load", onImageReady, { once: true });
                    img.addEventListener("error", onImageReady, { once: true });
                }
            });
        }

        var resizeTimer;
        window.addEventListener("resize", function () {
            window.clearTimeout(resizeTimer);
            resizeTimer = window.setTimeout(setup, 200);
        });
    });
}

function initOverlappingCards(wrapperSelector, cardSelector, activeClass) {
    var $wrapper = $(wrapperSelector);
    if (!$wrapper.length) {
        return;
    }

    var $cards = $wrapper.find(cardSelector);
    var hoverQuery = window.matchMedia("(hover: hover) and (pointer: fine)");

    function canHover() {
        return hoverQuery.matches;
    }

    function clearActive() {
        $cards.removeClass(activeClass);
    }

    $cards.on("click", function (event) {
        if (canHover()) {
            return;
        }

        event.stopPropagation();
        var $card = $(this);
        var alreadyActive = $card.hasClass(activeClass);
        clearActive();
        if (!alreadyActive) {
            $card.addClass(activeClass);
        }
    });

    $(document).on("click", function () {
        if (!canHover()) {
            clearActive();
        }
    });

    if (typeof hoverQuery.addEventListener === "function") {
        hoverQuery.addEventListener("change", clearActive);
    } else if (typeof hoverQuery.addListener === "function") {
        hoverQuery.addListener(clearActive);
    }
}

function initPricingCards() {
    initOverlappingCards(".pricing__cards-wrapper", ".pricing__card", "pricing__card--active");
}

function initContactPeopleCards() {
    initOverlappingCards(".contact-people__cards", ".contact-people__card", "contact-people__card--active");
}